import {useState, useCallback, RefObject, useRef, useEffect} from "react";

interface UseAnimatedToggleResult {
    isOpen: boolean;
    toggle: () => void;
    setIsOpen: (open: boolean) => void;
    ref: RefObject<HTMLDivElement>;
    maxHeight: string;
}

export function useAnimatedToggle(extraSpace = 50): UseAnimatedToggleResult {
    const [isOpen, setIsOpen] = useState(false);
    const [maxHeight, setMaxHeight] = useState('0px');
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            const height = ref.current.scrollHeight + extraSpace;
            setMaxHeight(isOpen ? `${height}px` : '0px');
        }
    }, [isOpen, extraSpace]);

    const toggle = useCallback(() => {
        setIsOpen(o => !o);
    }, []);

    return { isOpen, toggle, setIsOpen, ref, maxHeight };
}